import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/contact'
  },
  {
    path: '/contact',
    name: 'TMContact',

    component: () =>
      import(/* webpackChunkName: "TMContact" */ '@/views/HomePage/TMPage'),
    children: [
      {
        path: '/contact',
        name: 'TMContact',

        component: () =>
          import(/* webpackChunkName: "TMContact" */ '@/views/HomePage/TMPage')
      }
    ]
  },
  {
    path: '/online',
    name: 'OnlineContact',
    component: () => import('@/views/HomePage/OnlinePage')
  },
  {
    path: '/camp',
    name: 'CampContact',

    component: () =>
      import(/* webpackChunkName: "CampContact" */ '@/views/HomePage/CampPage')
  },
  {
    path: '/selected-course',
    name: 'SelectedCourse',

    component: () =>
      import(
        /* webpackChunkName: "SelectedCourse" */ '@/views/HomePage/SelectedCourse'
      )
  },

  // {
  //   path: '/yun/:code/:file',
  //   name: 'CloudPath',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "CloudPath" */ '@/views/KBShare/CloudFilePreview.vue'
  //     )
  // },

  {
    path: '*',
    component: () => import(/* webpackChunkName: "all" */ '@/views/404')
  }
]

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
})

export default router
